// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1rVmB","productName":"Table_productName__3qz3L"};